/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { Heading } from '@thd-olt-component-react/heading';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useIRG } from './useIRG';
import './item-related-groups.scss';

import { MultipleTabIRG } from './components/MultipleTabIRG';
import { MultipleAccordionIRG } from './components/MultipleAccordionIRG';
import { dataModel } from './dataModel';

const ItemRelatedGroups = (props) => {
  return (
    <>
      {/* eslint-disable-next-line */}
      <ItemRelatedGroupsChild {...props} />
    </>
  );
};

const ItemRelatedGroupsChild = (props) => {

  const {
    channel,
  } = useContext(ExperienceContext);

  const [dataSource, setDataSource] = useState('dynamicRecs');

  const {
    accordion,
    itemId,
    maxItems,
    dsNext,
    showMobileCardTabs
  } = props;

  const [{ tabs, ready }, {
    loadMoreForTab,
    loadSubCategory,
    setActiveTab,
    getActiveTab,
    removeItem
  }] = useIRG({
    itemId,
    maxItems,
    accordion
  });

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('item-related-groups.ready');
  }, []);

  const handleNext = ({ tab, limit = 8, start }) => {
    // @todo remove check when fully on ds 22.
    // ds22 should set dataSource to catalog
    if (dsNext) {
      setDataSource('catalog');
    }

    loadMoreForTab({
      tab: tab.name,
      limit,
      start,
      subCategory: tab.subCategory
    });
  };

  const handleCategory = useCallback(({ category, tab }) => {
    const opts = {
      tab: tab.name,
      subCategory: category?.subCategory
    };
    setActiveTab(opts);
    loadSubCategory(opts);
  }, []);

  const handleItemError = useCallback((id) => {
    removeItem(id);
  }, []);

  const storeId = useStoreId();
  const shouldSkip = ({ skip }) => {
    const defaultStoreId = tabs[0]?.storeId || '8119';
    if (defaultStoreId === '8119' && storeId !== '8119') {
      return true;
    }
    return skip;
  };

  const renderMultiIRG = () => {
    let MultiIrg = MultipleAccordionIRG;
    if (!accordion) {
      MultiIrg = MultipleTabIRG;
    }
    const defaultStoreId = tabs[0]?.storeId || '8119';

    return (
      <QueryProvider
        dataSource={dataSource}
        defaultVariables={{ skipSpecificationGroup: true, storeId: defaultStoreId }}
        skip={shouldSkip}
      >
        <MultiIrg
          tabs={tabs}
          onClickNext={handleNext}
          onClickCategory={handleCategory}
          onError={handleItemError}
          setActiveTab={setActiveTab}
          showMobileCardTabs={showMobileCardTabs}
        />
      </QueryProvider>
    );
  };

  const irgPodClasses = classNames(
    'item-related-groups', {
      'item-related-groups__irgdekstop': (channel !== 'mobile')
    }
  );

  const irgTabs = tabs.filter((tab) => tab.itemIds.length !== 0);
  return (
    <>
      {irgTabs.length !== 0 && (
        <div className={irgPodClasses}>
          {!accordion && <Heading title="Get Everything You Need" underline />}
          {renderMultiIRG()}
        </div>
      )}
    </>
  );
};

ItemRelatedGroupsChild.displayName = 'ItemRelatedGroups';
ItemRelatedGroupsChild.dataModel = dataModel;

ItemRelatedGroupsChild.propTypes = {
  accordion: PropTypes.bool,
  itemId: PropTypes.string,
  maxItems: PropTypes.number,
  dsNext: PropTypes.bool,
  showMobileCardTabs: PropTypes.bool
};

ItemRelatedGroupsChild.defaultProps = {
  accordion: false,
  itemId: null,
  maxItems: 8,
  dsNext: false,
  showMobileCardTabs: false
};

ItemRelatedGroups.dataModel = dataModel;

export { ItemRelatedGroups };
